import request from './http'
// jiashi_web
export function getJiashiWeb (data) {
  return request({
    method: 'post',
    url: '/jiashi-web/api',
    headers: { api_new: 'true' },
    data: data
  })
}
export function getToken (data) {
  return request({
    method: 'post',
    url: '/passport/api',
    headers: { api_new: 'true' },
    data: data
  })
}
// 发送验证码
export function jiashiSendCode (data) {
  return request({
    method: 'post',
    url: '/api/v1/m/message',
    headers: { jiashi_new: 'true' },
    data: data
  })
}
// 获取用户信息
export function jiashiUserInfo (data) {
  let url = ''
  if (data.mgrAccount) {
    url = '/api/v1/m/verifycodelogin?mgrAccount=' + data.mgrAccount
  } else {
    url = '/api/v1/m/verifycodelogin'
  }
  return request({
    method: 'post',
    url: url,
    headers: { jiashi_new: 'true' },
    data: data
  })
}
// 用户注册
export function jiashiPreregister (data) {
  const reqData = {
    mobile: data.mobile,
    mgrAccount: data.mgrAccount
  }
  let url = ''
  if (reqData.mgrAccount) {
    url = '/api/v1/m/register?mgrAccount=' + reqData.mgrAccount
  } else {
    url = '/api/v1/m/register'
  }
  return request({
    method: 'post',
    url: url,
    headers: { jiashi_new: 'true', sessionkey: data.sessionKey },
    data: reqData
  })
}
//
